
import { useState } from "react";
import {  useSelector } from 'react-redux';

import userApi from "../../api/userApi";
import { dataValidator } from "../../tools/dataValidator";
import useMount from '../../hooks/useMount';
import { getLabel } from "../../tools/Dictionary";
import { formatUTCToLocal } from "../../tools/GeneralHelper";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import LoadingComponent from "../Commons/LoadingComponent";
import { getLanguages } from "../../slices/languageSlice";
import ActionButton from "../Commons/ActionButton";

import { MdPassword, MdAssignmentInd } from "react-icons/md";

const UserModal = (props) => {

  //Redux
  const Language = useSelector(getLanguages);

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const Id = props.Id;
  const TemperatureUnit = props.TemperatureUnit;
  const Role = props.Role;
  const OnCloseModal = props.OnCloseModal;
  const LoadData = props.LoadData;


  //State
  const [user, setUser] = useState(undefined);
  const [form, setForm] = useState(undefined);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [isUpdate] = useState(Id && Id != 0);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });



  //Variables
  const baseForm = {
    _id: 0,
    email: "",
    firstName: "",
    lastName: "",
    languageCode: Language[0].code,
    temperatureUnit: TemperatureUnit[0]._id,
    companyName: "",
    isValid: false,
    isVerified: false,
    verifySent: false,
    retryCount: 0,
    isLocked: false,
    isActive: false,
    role: {},
    lastLoginAt: null
  }


  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async() => {

    if (isUpdate){

      try{

        setLoading(true);

        let response = await userApi.getUser(Id);

        if (!response.Success)
        {

          let error = new Error()
          error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

          throw error;

        }


        setUser(response.Data);
        setForm({
          _id: response.Data._id,
          email: response.Data.email,
          firstName: response.Data.firstName,
          lastName: response.Data.lastName,
          languageCode: response.Data.languageCode,
          temperatureUnit: response.Data.temperatureUnit._id,
          companyName: response.Data.companyName,
          isValid: response.Data.isValid,
          isVerified: response.Data.isVerified,
          verifySent: response.Data.verifySent,
          retryCount: response.Data.retryCount,
          isLocked: response.Data.isLocked,
          isActive: response.Data.isActive,
          role: response.Data.role.id,
          lastLoginAt: response.Data.lastLoginAt
        })

        setLoading(false);

      }catch(err){


        setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: onFatalError,
          Display: true
        });

      }

    }else{
      //Add
      setForm(baseForm);
      setLoading(false);
    }

  };

  const onFatalError = async() => {

    setAlert(alert => ({ ...alert, Display: false }));

    await LoadData();

    setLoading(false);

    OnCloseModal();

  };

  const onChangeEmail = (e) => {

    let email = e.target.value;


    onValidateField("email", email); //Validate field value

    setForm(form => ({
      ...form,
      email
    }));

  };

  const onChangeFirstName = (e) =>
  {

    let firstName = e.target.value;


    onValidateField("firstName", firstName); //Validate field value

    setForm(form => ({
      ...form,
      firstName
    }));

  };

  const onChangeLastName = (e) =>
  {

    let lastName = e.target.value;


    onValidateField("lastName", lastName); //Validate field value

    setForm(form => ({
      ...form,
      lastName
    }));

  };


  const onChangeCompanyName = (e) =>
  {

    let companyName = e.target.value;


    onValidateField("companyName", companyName); //Validate field value

    setForm(form => ({
      ...form,
      companyName
    }));

  };



  const onChangeRole = (e) =>
  {

    let role = e.target.value;


    onValidateField("role", role); //Validate field value

    setForm(form => ({
      ...form,
      role
    }));

  };

  const onChangeLanguage = (e) =>
  {

    let language = e.target.value;


    onValidateField("language", language); //Validate field value

    setForm(form => ({
      ...form,
      language
    }));

  };

  const onChangeTemperatureUnit = (e) =>
  {

    let temperatureUnit = e.target.value;


    onValidateField("temperatureUnit", temperatureUnit); //Validate field value

    setForm(form => ({
      ...form,
      temperatureUnit
    }));

  };

  const onChangeIsValid = () =>
  {

    setForm(form => ({
      ...form,
      isValid: !form.isValid
    }));

  };

  const onChangeIsVerified = () =>
  {

    setForm(form => ({
      ...form,
      isVerified: !form.isVerified
    }));

  };

  const onChangeIsLocked = () =>
  {

    setForm(form => ({
      ...form,
      isLocked: !form.isLocked
    }));

  };

  const onChangeIsActive = () =>
  {

    setForm(form => ({
      ...form,
      isActive: !form.isActive
    }));

  };
  


  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "email";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:320", "email"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

   
    currentField = "firstName";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:60"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }


    currentField = "lastName";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:60"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }


    currentField = "companyName";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["max:100"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }


    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };


  const onClickResetPassword = () => {

    setConfirm(({
      Title: getLabel("UserPage", "Reset Password"),
      Message: getLabel("UserPage", "This action will reset the user's password..."),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onResetPassword,
      Display: true
    }));
    
  };

  const onResetPassword = async() => {

    setConfirm(confirm => ({ ...confirm, Display: false }));


    try
    {

      setLoading(true);


      let response = await userApi.resetPassword({_id: form._id});

      if (!response.Success)
      {


        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label, response.Error.parameter) : undefined;

        throw error;

      }


      setAlert({
        Title: getLabel("UserPage", "The user's password has been reset"),
        Message: getLabel("UserPage", "The user's password has been reset, and an email..."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });



      setLoading(false);



    } catch (err)
    {

      setLoading(false);


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };

  const onClickValidate = () =>
  {

    setConfirm(({
      Title: getLabel("UserPage", "Validate"),
      Message: getLabel("UserPage", "By validating this account, the user will gain access to this application."),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onValidateAccount,
      Display: true
    }));

  };

  const onValidateAccount = async () =>
  {

    setConfirm(confirm => ({ ...confirm, Display: false }));


    try
    {

      setLoading(true);


      let response = await userApi.validateUser({ _id: form._id });

      if (!response.Success)
      {


        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label, response.Error.parameter) : undefined;

        throw error;

      }


      setAlert({
        Title: getLabel("UserPage", "This account has been validated."),
        Message: getLabel("UserPage", "This account has been validated, and an email has been sent to the user."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });



      setLoading(false);



    } catch (err)
    {

      setLoading(false);


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };
 
  const onClickSave = async() => {

    try
    {

      setLoading(true);


      let parameters = {
        _id: form._id,
        email: form.email,
        firstName: form.firstName,
        lastName: form.lastName,
        languageCode: form.languageCode,
        temperatureUnit: form.temperatureUnit,
        companyName: form.companyName,
        isValid: form.isValid,
        isVerified: form.isVerified,
        isLocked: form.isLocked,
        isActive: form.isActive,
        role: form.role
      };

      let response = await userApi.updateUser(parameters);

      if (!response.Success)
      {


        let error = new Error();
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label, response.Error.parameter) : undefined;

        throw error;

      }


      await LoadData();

      setLoading(false);


      OnCloseModal();


    } catch (err)
    {

      setLoading(false);


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };



  if (!form) return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("UserPage", "User")}
        </div>
        <div className="page_modal_body_cont" />
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
          isCover={true}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{marginBottom: "0px"}}>
          {getLabel("UserPage", "User")}
        </div>
        <div className="page_modal_header_action_cont">
          <ActionButton
            IsDesktop={IsDesktop}
            Label={getLabel("UserPage", "Reset Password")}
            Icon={MdPassword}
            Disabled={loading}
            OnClick={onClickResetPassword}
            buttonStyle={{fontSize: "80%", marginRight: "10px"}}
          />
          {!user.valid && 
            <ActionButton
              IsDesktop={IsDesktop}
              Label={getLabel("UserPage", "Validate")}
              Icon={MdAssignmentInd}
              Disabled={loading}
              OnClick={onClickValidate}
              buttonStyle={{ fontSize: "80%", marginLeft: "10px" }}
          />
          }
          
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "email")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["email"] ? "page_modal_body_col_input_error" : "")}
                value={form.email || ""}
                type="text"
                style={{ width: "100%" }}
                onChange={onChangeEmail}
                disabled={!Access.canWrite || loading}
              />
              {error["email"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["email"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "firstName")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["firstName"] ? "page_modal_body_col_input_error" : "")}
                value={form.firstName || ""}
                type="text"
                style={{ width: "100%" }}
                onChange={onChangeFirstName}
                disabled={!Access.canWrite || loading}
              />
              {error["firstName"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["firstName"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "lastName")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["lastName"] ? "page_modal_body_col_input_error" : "")}
                value={form.lastName || ""}
                type="text"
                style={{ width: "100%" }}
                onChange={onChangeLastName}
                disabled={!Access.canWrite || loading}
              />
              {error["lastName"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["lastName"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "companyName")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["companyName"] ? "page_modal_body_col_input_error" : "")}
                value={form.companyName || ""}
                type="text"
                style={{ width: "100%" }}
                onChange={onChangeCompanyName}
                disabled={!Access.canWrite || loading}
              />
              {error["companyName"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["companyName"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "role")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <select
                value={form.role || ""}
                className={"page_select_input"}
                onChange={onChangeRole}
                style={{ width: "200px", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || loading}
              >
                {Role.map((l, index) => (
                  <option key={index} value={l._id} style={{ textAlign: "center", color: "black" }}>
                    {l.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "language")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <select
                value={form.languageCode || ""}
                className={"page_select_input"}
                onChange={onChangeLanguage}
                style={{ width: "200px", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || loading}
              >
                {Language.map((l, index) => (
                  <option key={index} value={l.code} style={{ textAlign: "center", color: "black" }}>
                    {l.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "temperatureUnit")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <select
                value={form.temperatureUnit || ""}
                className={"page_select_input"}
                onChange={onChangeTemperatureUnit}
                style={{ width: "200px", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || loading}
              >
                {TemperatureUnit.map((t, index) => (
                  <option key={index} value={t._id} style={{ textAlign: "center", color: "black" }}>
                    {t.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "isValid")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <label className="page_switch">
                <input
                  type="checkbox"
                  checked={form.isValid}
                  onChange={onChangeIsValid}
                  disabled={!Access.canWrite || loading}
                />
                <span className="page_slider round" />
              </label>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "isVerified")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <label className="page_switch">
                <input
                  type="checkbox"
                  checked={form.isVerified}
                  onChange={onChangeIsVerified}
                  disabled={!Access.canWrite || loading}
                />
                <span className="page_slider round" />
              </label>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "isLocked")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <label className="page_switch">
                <input
                  type="checkbox"
                  checked={form.isLocked}
                  onChange={onChangeIsLocked}
                  disabled={!Access.canWrite || loading}
                />
                <span className="page_slider round" />
              </label>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "isActive")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <label className="page_switch">
                <input
                  type="checkbox"
                  checked={form.isActive}
                  onChange={onChangeIsActive}
                  disabled={!Access.canWrite || loading}
                />
                <span className="page_slider round" />
              </label>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_User", "lastLoginAt")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "200px" }} >
              <input
                className={"page_text_input " + (error["email"] ? "page_modal_body_col_input_error" : "")}
                value={form.lastLoginAt ? formatUTCToLocal(form.lastLoginAt) : "-"}
                type="text"
                style={{ width: "100%" }}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading) ? undefined : () => OnCloseModal()}
            disabled={loading}
          />
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Save")}
            style={{ maxWidth: "200px" }}
            onClick={(loading) ? undefined : onClickSave}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default UserModal;